import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

/** Server-Sent Events (§11A.2): invalidate review-queue / dashboard / document queries on item events. */
export function useLiveUpdates(enabled: boolean): void {
  const qc = useQueryClient();
  useEffect(() => {
    if (!enabled) return;
    const es = new EventSource("/portal/v1/stream", { withCredentials: true });
    const bump = () => {
      void qc.invalidateQueries({ queryKey: ["items"] });
      void qc.invalidateQueries({ queryKey: ["dashboard"] });
    };
    for (const type of ["item.accepted", "item.needs_review", "item.needs_input", "item.quarantined", "item.duplicate",
      "item.restored", "item.reclassified", "message.received", "whatsapp.group.join_requested", "mirror.conflict"]) {
      es.addEventListener(type, bump);
    }
    return () => es.close();
  }, [enabled, qc]);
}
